import { pm2ConfigStore } from '@pm2/store';
import { Link } from '@provider/navigation';
import { breakpoints } from '@ui/css';
import { PublisherLogo } from '@ui/kit/icons';
import { HideFor } from '@utils/react';
import { logoCls, publisherLogoCls, portalLogoCls } from './Logo.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Logo = () => {
  const publisher = pm2ConfigStore.useSelector(state => state.config.publisher);
  const subject = pm2ConfigStore.useSelector(state => state.config.theme.logo.subject);
  const grades = pm2ConfigStore.useSelector(state => state.config.theme.logo.grades);
  const classLabel = pm2ConfigStore.useSelector(state => state.config.theme.logo.classLabel);
  return /*#__PURE__*/jsxs(Link, {
    className: logoCls,
    href: "/",
    "aria-label": "G\xE5 til forsiden af portalen",
    children: [publisher !== "louisiana" && /*#__PURE__*/jsx("i", {
      className: publisherLogoCls,
      children: /*#__PURE__*/jsx(PublisherLogo, {
        small: true
      })
    }), /*#__PURE__*/jsxs("span", {
      className: portalLogoCls,
      children: [/*#__PURE__*/jsx("b", {
        children: subject
      }), grades && ` ${grades}`, /*#__PURE__*/jsx(HideFor, {
        breakpoint: breakpoints.mobile,
        children: classLabel && ` ${classLabel}`
      })]
    })]
  });
};

export { Logo };
//# sourceMappingURL=Logo.js.map
